import { CSSProperties, memo, useMemo } from "react"
import { OrderStatus } from "../../proto/generated/order";
import { getOrderStatusColor, getOrderStatusText } from "../../util/orders";

export type OrderStatusProps = {
    status: OrderStatus,
    style?: CSSProperties
}

const OrderStatusDisplay: React.FC<OrderStatusProps> = ( {status, style = {}} ) => {

    const mergedStyles: CSSProperties = useMemo(() => ({ ...style, color: getOrderStatusColor(status)}), [status, style])
    return <span style={mergedStyles} >{getOrderStatusText(status)}</span>;
}

export default memo(OrderStatusDisplay)